export var extractCategoryFromJRNICategoryName = function (jrniCategoryName) {
    if (/Kitchen/i.test(jrniCategoryName))
        return 'Kitchen';
    if (/Storage/i.test(jrniCategoryName))
        return 'Bedroom';
    // Previous solution
    return jrniCategoryName.split(' ').pop();
};
